import AnalyticsEvents_V2 from '../analyticsGA4'
import { Labels, PortalProducts } from '../types/analytics.type'

import { MathVaultEvents, MathVaultPathObject } from './mathVaultEvents.types'

class MathVaultAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.MATHVAULT)
  }

  public clickOnCheckAnswerBtn(correct: boolean, activityPath: MathVaultPathObject): void {
    const status = correct ? Labels.CORRECT : Labels.INCORRECT
    this.logEvent({ event: MathVaultEvents.CLICK_ON_CHECK_ANSWER_BTN, status, ...activityPath })
  }

  public toggleHelpModalOpenClose(
    activityData: MathVaultPathObject & { encyclopedia_reference_key: string },
    open: boolean,
  ): void {
    const event = open ? MathVaultEvents.OPENED_HELP_MODAL : MathVaultEvents.CLOSED_HELP_MODAL

    this.logEvent({ event, ...activityData })
  }

  public clickOnQuestionImage(activityPath: MathVaultPathObject): void {
    this.logEvent({ event: MathVaultEvents.CLICK_ON_QUESTION_IMAGE, ...activityPath })
  }

  public clickOnPreviousBtn(activityPath: MathVaultPathObject): void {
    this.logEvent({ event: MathVaultEvents.CLICK_ON_PREVIOUS_BTN, ...activityPath })
  }

  public clickOnSkipBtn(activityPath: MathVaultPathObject): void {
    this.logEvent({ event: MathVaultEvents.CLICK_ON_SKIP_BTN, ...activityPath })
  }

  public logOpenedAuthenticationPrompt(eventParam: MathVaultPathObject): void {
    this.logEvent({
      event: MathVaultEvents.OPENED_AUTHENTICATION_PROMPT,
      product: PortalProducts.NAVIGATION,
      ...eventParam,
    })
  }
}

const mathVaultAnalytics = new MathVaultAnalytics()

export default mathVaultAnalytics
